import React, { Suspense, lazy } from 'react';
import Hero from '../components/Hero';
import Brands from '../components/Brands';
import HomePageData from '../data/HomePageData.json';
import { Helmet } from 'react-helmet-async';

// Lazy load components below the fold
const About = lazy(() => import('../components/About'));
const Projects = lazy(() => import('../components/Projects'));
const Service = lazy(() => import('../components/Service'));
const DevProjects = lazy(() => import('../components/DevProjects'));
const Experience = lazy(() => import('../components/Experience'));
const Blog = lazy(() => import('../components/Blog'));
const Education = lazy(() => import('../components/Education'));
const Contact = lazy(() => import('../components/Contact'));

export default function Home() {
  const {
    hero,
    socialBtns,
    brands,
    about,
    projects,
    service,
    devProjects,
    experience,
    education,
    contact,
    blogs,
  } = HomePageData;
  return (
    <>
      <Helmet>
        <title>Kunal Das | Cybersecurity Researcher & Trainer</title>
        <meta name="description" content="Portfolio of Kunal Das, a Cybersecurity Researcher specializing in VAPT, OSINT, and web application security, and Co-Founder & Trainer at EncryptArx." />
        <meta property="og:title" content="Kunal Das | Cybersecurity Researcher & Trainer" />
        <meta property="og:description" content="Portfolio of Kunal Das, a Cybersecurity Researcher specializing in VAPT, OSINT, and web application security." />
        <meta property="og:image" content="https://kunaldas.tech/images/home-banner.webp" />
        <meta property="og:url" content="https://kunaldas.tech/" />
        <link rel="canonical" href="https://kunaldas.tech/" />
      </Helmet>
      {/* Above the fold (Loaded immediately) */}
      <Hero data={hero} socialData={socialBtns} />
      <Brands data={brands} />

      {/* Below the fold (Lazy loaded to improve initial load time) */}
      <Suspense fallback={null}>
        <About data={about} />
        <Projects data={projects} />
        <Service data={service} />
        <DevProjects data={devProjects} />
        <Experience data={experience} />
        <Blog data={blogs} />
        <Education data={education} />
        <Contact data={contact} socialData={socialBtns} />
      </Suspense>
    </>
  );
}
